<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Mantenedor Corredores</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          
            <b-row class="my-1">
              <b-col sm = "2">
                <label>Corredor</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="consulta_corredor()" > 
                  <b-input-group @submit.prevent="consulta_corredor()">
                    <b-form-input type="text" v-model="datosFormulario.codCorredor"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.IdNacionCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="4">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.NombreCorred"/>
                </b-input-group>
              </b-col>
            </b-row>

            

          <div slot="footer">
            <div class="t-ButtonRegion-wrap">
                <div class="t-ButtonRegion-col t-ButtonRegion-col--left">
                  <b-button variant="primary" @click="categorias"> Categorías Contacto</b-button>
                </div>

                <div class="t-ButtonRegion-col t-ButtonRegion-col--content">
                </div>

                <div class="t-ButtonRegion-col t-ButtonRegion-col--right">
                  <b-button variant="primary" @click="buscar" style="margin-right: 10px;"><i class="fa fa-search"></i> Consultar</b-button>
                  <b-button variant="primary" @click="pre_insertar" style="margin-right: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                  <b-button variant="primary" @click="descargarExcel" ><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                </div>    
                
              
            </div>
          </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Mantenedor Corredores</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>

                <el-table-column label="" min-width="50px" align="center">
                <template slot-scope="scope">
                    <el-button
                          size="mini"
                          type="primary"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  <b-modal
      title="Modificación Corredor"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalModificar"
      @ok="saveRow();"
      @cancel="modalModificar = false"
    >
    
      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicnombrecorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Rut Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicrutcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Código Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.giccodcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Estado Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <b-form-radio v-model="datosFormularioModal.gicestadocorredor" value="Vigente">Vigente</b-form-radio>
            <b-form-radio v-model="datosFormularioModal.gicestadocorredor" value="No Vigente">No Vigente</b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Última Modificación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicultimamodedocorr">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Usuario</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.gicusumodedocorr">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
    
    </b-modal>

    <b-modal
      title="Categorías Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalCategorias"
      @ok="saveAll();"
      @cancel="modalCategorias = false"
    >
      <div>
        
        
        <b-row class="my-3">
          <b-col sm="6"> </b-col>
          <b-col sm="6" align="right"> 
          <b-button size="sm" variant="info" @click="addRow" style="color: #ffffff; margin-left: 10px;">Agregar + </b-button>
          </b-col> 
        </b-row>
        <b-row class="my-1">
          <el-table 
            ref="refTableDataCategorias"
            :data="tableData"
            style="width: 100%"
            border
            max-height="800px"
            :row-class-name="tableRowClassName">
                  
              <el-table-column prop="CCOCATEGORIA" label="Categoria" width="120" align="center">
                <template slot-scope="scope">
                  <b-form-input id="CCOCATEGORIA" size="sm" maxlength="1" v-model="scope.row.CCOCATEGORIA" style="text-align:center"></b-form-input>
                </template>
              </el-table-column>
              <el-table-column prop="CCODESCRIPCION" label="Definición Categoria" width="280" align="left">
                <template slot-scope="scope">
                  <b-form-input id="CCODESCRIPCION" size="sm"  v-model="scope.row.CCODESCRIPCION" style="text-align:left"></b-form-input>
                </template>
              </el-table-column>
              <el-table-column prop="CCOFEMODIFICACION" label="Fecha Modificación" width="120" align="center"></el-table-column>
              <el-table-column prop="CCOUSUARIO" label="Usuario" width="120" align="center"></el-table-column>
              <el-table-column align="center">
                <template slot-scope="scope">
                  <el-button size="small" variant="info" @click.native.prevent="deleteRow(scope.$index, scope.row)" >   Borrar   </el-button>
                </template>
              </el-table-column>
          </el-table>
        </b-row>

      </div>
    </b-modal>

    
  
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiBaseMantCorredor from "@/components/services/apiBaseMantCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "BaseAsegurado",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      modalModificar: false,
      modalCategorias: false,
      hasCorredor : false,
      exportar: false,
      notificacion: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      selectedCor: [],
      selectedDire:[],
      
      data: [],
      nombreexcel: "Mantenedor Corredores",
      titles: [
        {
          prop: "gicnombrecorredor",
          label: "Nombre Corredor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "gicrutcorredor",
          label: "Rut Corredor",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "giccodcorredor",
          label: "Código Corredor",
          align: "center",
          minwidth:'80'
        },
         {
          prop: "gicestadocorredor",
          label: "Estado Corredor",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "gicultimamodedocorr",
          label: "Última Modificación",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "gicusumodedocorr",
          label: "Usuario",
          align: "center",
          minwidth:'80'
        }
        
      ],
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      datosFormularioModal: {
          gicnombrecorredor: "",
          gicrutcorredor: "",
          giccodcorredor: "",
          gicestadocorredor: "",
          gicultimamodedocorr: "",
          gicusumodedocorr: "",
          gicdireccionlegal: "",
          gicciudadlegal: "",
          giccomunalegal: ""
      },
      
      mostrarFechas: true,
      datosFormulario: {
          codCorredor: "",
          IdNacionCorred: "",
          NombreCorred: ""
      },

      value: null,
      tableData :[],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        // rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.modificarContacto(row);
          }
          botones.push(obj);
          
          return botones;

    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    tableRowClassName({ row }) {
      if(row.marca == "1"){
            return 'danger-row';
        }
        else{
            return 'estiloFilaTabla';
        }
      
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },
    
    pre_insertar() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.codCorredor ="";
      this.datosFormulario.NombreCorred ="";
      this.datosFormulario.IdNacionCorred ="";
      this.hasCorredor = false;
      

      return apiBaseMantCorredor
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.codCorredor='';
          
          this.datosFormularioEstado = response.data.festado;
          
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    categorias(){
      this.modalCategorias = true;
      this.recuperarcategorias();
    },

    deleteRow(index, rows) {

      // this.tableData.splice(index, 1);

        return apiBaseMantCorredor
          .eliminarcategoria(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.CCOCATEGORIA
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Categoría eliminada exitosamente",
                "success"
              );
              
              this.tableData.splice(index, 1);
              
            }
            else{
              
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    },

    saveAll:function(){
     this.tableData.forEach((column, index) => {
        return apiBaseMantCorredor
          .insertupdatcategorias(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            column["CCOCATEGORIA"],
            column["CCODESCRIPCION"]
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            
            if (response.data.festado.resultado.estado != "error"){
              
              this.notificacion = true;
            }
            else{
              
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();    
          })
      })

      if (this.notificacion === true){
            this.crearNotificacion(
                "Insertar",
                "Categoría registrada exitosamente.",
                "success"
              );
          }
    },

    addRow:function(){
      let newRow  = {
              ccocategoria:"",
              ccodescripcion:"",

            };
            
      this.tableData = [newRow,...this.tableData];
      ++ this.addCount;
      },

    recuperarcategorias() {
      this.$Progress.start();
      this.tableData = [];
      return apiBaseMantCorredor
        .recuperarcategorias(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          
          this.tableData = response.data.res;
          
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
                
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },  


    buscar() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;
      
      var p_corredor = this.datosFormulario.codCorredor == ''? '0' : this.datosFormulario.codCorredor;
      
      return apiBaseMantCorredor
      .recuperarmantcorr(p_email, p_corredor)
          .then( (response)=>{

            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "fecha"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      
      ///COLUMNAS ESCRIBIR
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      //for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Rut Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Código Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Estado Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Última Modificación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Usuario" + "</td>\n";
      //}
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      let diadiapol = '';
      let decididor = '';
      for (var key in this.data) {
        if(this.data[key]["gicnombrecorredor"] === undefined){ 
          this.data[key]["gicnombrecorredor"] = "";
        }
        if(this.data[key]["gicrutcorredor"] === undefined){ 
          this.data[key]["gicrutcorredor"] = "";
        }
        if(this.data[key]["giccodcorredor"] === undefined){ 
          this.data[key]["giccodcorredor"] = "";
        }
        if(this.data[key]["gicestadocorredor"] === undefined){ 
          this.data[key]["gicestadocorredor"] = "";
        }
        if(this.data[key]["gicultimamodedocorr"] === undefined){ 
          this.data[key]["gicultimamodedocorr"] = "";
        }
        
        if(this.data[key]["gicusumodedocorr"] == undefined){ 
          this.data[key]["gicusumodedocorr"] = "";
        }
        

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicnombrecorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicrutcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["giccodcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicestadocorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["gicultimamodedocorr"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["gicusumodedocorr"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      //Data bloque 1
      
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },


    consulta_corredor: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasCorredor = false;
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      var p_email = this.$session.get("mail");
      
      if ((p_corredor==0) || (p_corredor=="")){
          this.datosFormulario.IdNacionCorred = "";
          this.datosFormulario.NombreCorred ="";
          this.mensaje= "Ingrese SR Corredor.";
          this.variant="warning";
          this.showAlert();
          return false;
      }
      return apiBaseMantCorredor
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoCorredor = response.data.res;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["peridnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["pernombreimp"];
          }
          
          // this.hasCorredor = true;
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    nuevoContacto: function(){
      this.datosFormularioModal.gicidinfcorr = "";
      this.datosFormularioModal.gicnombrecorredor = this.datosFormulario.NombreCorred;
      this.datosFormularioModal.gicrutcorredor = this.datosFormulario.IdNacionCorred;
      this.datosFormularioModal.giccodcorredor = this.datosFormulario.codCorredor;
      // this.datosFormularioModal.gicnomcontacto = this.datosFormulario.addnomcontacto;
      // this.datosFormularioModal.gicapellcontacto = this.datosFormulario.addapellcontacto;
      // this.datosFormularioModal.giccargo = this.datosFormulario.addcargo;
      // this.datosFormularioModal.gicmail = this.datosFormulario.addmail;
      // this.datosFormularioModal.gictelefonofijo = this.datosFormulario.addtelefonofijo;
      // this.datosFormularioModal.gictelefonomovil = this.datosFormulario.addtelefonomovil;
      // this.datosFormularioModal.giccontactocomcred = this.datosFormulario.addcontactocomcred;
      // this.datosFormularioModal.giccontactoventas = this.datosFormulario.addcontactoventas;
      // this.datosFormularioModal.giccontactosiniestro = this.datosFormulario.addcontactosiniestro;
      // this.datosFormularioModal.giccontactogarantia = this.datosFormulario.addcontactogarantia;
      // this.datosFormularioModal.giccontactorecuperos = this.datosFormulario.addcontactorecuperos;
      this.datosFormularioModal.gicdireccionlegal = this.datosFormulario.gicdireccionlegal;
      this.datosFormularioModal.gicciudadlegal = this.datosFormulario.gicciudadlegal;
      this.datosFormularioModal.giccomunalegal = this.datosFormulario.giccomunalegal;
      // this.datosFormularioModal.gicdireccionparticular = this.datosFormulario.adddireccionparticular;
      // this.datosFormularioModal.gicciudad = this.datosFormulario.addciudad;
      // this.datosFormularioModal.giccomuna = this.datosFormulario.addcomuna;
      // this.datosFormularioModal.gicfechacumpleanos = this.datosFormulario.addfechacumpleanos;
      // this.datosFormularioModal.giccategoriacontacto = this.datosFormulario.addcategoriacontacto;
      // this.datosFormularioModal.gicobservacion = this.datosFormulario.addobservacion;
      this.datosFormularioModal.gicultimamodificacion = this.datosFormulario.addultimamodificacion;
      this.datosFormularioModal.gicusuario = this.datosFormulario.addusuario;
      // this.datosFormularioModal.gicestado = this.datosFormulario.addestado;
      this.modalNuevo = true;
    },

    modificarContacto: function( row ){
      this.datosFormularioModal.gicnombrecorredor = row.gicnombrecorredor;
      this.datosFormularioModal.gicrutcorredor = row.gicrutcorredor;
      this.datosFormularioModal.giccodcorredor = row.giccodcorredor;
      this.datosFormularioModal.gicestadocorredor = row.gicestadocorredor;
      this.datosFormularioModal.gicultimamodedocorr = row.gicultimamodedocorr;
      this.datosFormularioModal.gicusumodedocorr = row.gicusumodedocorr;
      this.modalModificar = true;
    },

    saveRow() { 
      console.log(this.datosFormularioModal);
      let rows = this.datosFormularioModal;
      var p_id = rows.giccodcorredor;
      var vestado="";
      var vMensaje="";
      
      if ((parseInt(p_id)>0) && (this.modalModificar)){
        //Modificar
        return apiBaseMantCorredor
          .editarCorredor(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.giccodcorredor,
            rows.gicestadocorredor
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha editado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
      }else{
        return apiBaseCorredor  
          .insertar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.giccodcorredor,
            rows.gicnomcontacto,
            rows.gicapellcontacto,
            rows.giccargo,
            rows.gicmail,
            rows.gictelefonofijo,
            rows.gictelefonomovil,
            rows.giccontactocomcred,
            rows.giccontactoventas,
            rows.giccontactosiniestro,
            rows.giccontactogarantia,
            rows.giccontactorecuperos,
            rows.gicdireccionparticular,
            rows.gicciudad,
            rows.giccomuna,
            rows.gicfechacumpleanos,
            rows.giccategoriacontacto,
            rows.gicestado,
            rows.gicobservacion,
            rows.gicultimamodificacion,
            rows.gicusuario
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Se ha guardado el nuevo contacto.",
                "success"
              );
            }
            else{

              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
      }
    },
    
    eliminarContacto(row){
      this.datosFormularioModal.gicidinfcorr = row.gicidinfcorr;
      this.datosFormularioModal.gicnomcontacto = row.gicnomcontacto;
      this.datosFormularioModal.gicapellcontacto = row.gicapellcontacto;
      this.modalEliminar = true;
    },

    eliminarGuardar(){
      return apiBaseCorredor
          .eliminar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormularioModal.gicidinfcorr
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Eliminar",
                "Se ha eliminado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    }
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();    
    //this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}

.t-ButtonRegion-wrap {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-areas: "button-left button-content button-right";
    align-items: center;
}

.t-ButtonRegion-col--left .t-ButtonRegion-buttons {
    text-align: left;
    padding: var(--ut-button-region-padding, 16px);
}

.t-ButtonRegion-col--content {
    padding: var(--ut-button-region-padding, 16px);
}

</style>
